import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'appCapitalFirstLetter',
  standalone: true,
  pure: true,
})
export class CapitalFirstLetterPipe implements PipeTransform {
  transform(substring: string): string {
    if (!substring) {
      return '';
    }

    return substring
      .split(' ')
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(' ');
  }
}
